/**
 * @generated SignedSource<<3fef61a77a500a6cda73c87826f428ac>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type InspectionStateEnum = "APPROVED" | "ASSIGNED" | "IN_PROGRESS" | "PLANNED" | "REJECTED" | "RETRY" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type InspectionReportCard$data = {
  readonly approvedDate: any | null;
  readonly id: string;
  readonly inspectionfield: {
    readonly collective: {
      readonly name: string;
    } | null;
    readonly managementPackageSetting: {
      readonly displayNameAlt: string | null;
    } | null;
    readonly year: number;
  };
  readonly inspector: {
    readonly firstName: string;
    readonly lastName: string;
    readonly user: {
      readonly firstName: string;
      readonly lastName: string;
    } | null;
  } | null;
  readonly pdfName: string | null;
  readonly rejectedDate: any | null;
  readonly report: {
    readonly id: string;
    readonly pdf: {
      readonly downloadUrl: string | null;
    } | null;
  } | null;
  readonly retry: boolean;
  readonly retryDate: any | null;
  readonly state: InspectionStateEnum | null;
  readonly " $fragmentType": "InspectionReportCard";
};
export type InspectionReportCard$key = {
  readonly " $data"?: InspectionReportCard$data;
  readonly " $fragmentSpreads": FragmentRefs<"InspectionReportCard">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InspectionReportCard",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "InspectorNode",
      "kind": "LinkedField",
      "name": "inspector",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "UserNode",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            (v2/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "InspectionfieldNode",
      "kind": "LinkedField",
      "name": "inspectionfield",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CollectiveNode",
          "kind": "LinkedField",
          "name": "collective",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "year",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ManagementPackageSettingsNode",
          "kind": "LinkedField",
          "name": "managementPackageSetting",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "displayNameAlt",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "InspectionReportNode",
      "kind": "LinkedField",
      "name": "report",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "StorageObjectNode",
          "kind": "LinkedField",
          "name": "pdf",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "downloadUrl",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "state",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "approvedDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rejectedDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "retryDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "retry",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pdfName",
      "storageKey": null
    }
  ],
  "type": "InspectionNode",
  "abstractKey": null
};
})();

(node as any).hash = "e6856eef11729f3fedb6eb6cd2ba62b1";

export default node;
